import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import { SgdsMasthead } from "@govtechsg/sgds-masthead-react";

import Navbar from "../../Components/NavbarComponent";
import FooterComponent from "../../Components/FooterComponent";
import SideNavComponent from "../../Components/SideNavComponent";
import MastheadAnnouncement from '../../Components/MastheadAnnouncement'

import Endpoint from "../../Components/Endpoint";
import endpointsData from "../../json/sampleEndpts.json";

import { Button } from "@govtechsg/sgds-react/Button";
import arrowleft from "../../assets/icons/arrow-left.svg";
import arrowright from "../../assets/icons/arrow-right.svg";

const PlanningAreaServices = () => {
  const location = useLocation();

  const endpointreturn = (id) => {
    let endpt_elem = endpointsData;

    endpt_elem = endpt_elem.find((item) => item.page_section === id);

    const pythonCode = `import requests
    \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
    \nheaders = {"Authorization": "**********************"}
    \nresponse = requests.request("GET", url, headers=headers)
    \nprint(response.text)`;

    const jsCode = `const url = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}";
const authToken = '**********************';  // Replace with your access token

fetch(url, {
  method: '${endpt_elem.method}',
  headers: {
    'Authorization': \`\${authToken}\`,  // API token for authorization
  }
})
.then(response => response.json())  // Parse response as JSON
.then(data => console.log(data))     // Log the data to the console
.catch(error => console.error('Error:', error));  // Log any errors`;
    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const { state } = location;
  const [activeKey, setActiveKey] = useState("");
  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };
  useEffect(() => {
    if (state === null) {
      clickButton("0");
    } else {
      clickButton(location.state.toString());
    }
  }, [state]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>

      <Helmet>
        <title>Access Singapore's URA Planning Area Polygons & Names | OneMap API</title>
        <meta
          name="description"
          content="Retrieve detailed planning area polygons and names for Singapore's 55 planning areas using the Planning Area API. Access data for the latest master plan or specific years (1998, 2008, 2014, 2019) to support geospatial analytics and development of location-based solutions."
        />
      </Helmet>
      <MastheadAnnouncement/>
      <Navbar />
      <div className="row qx-0 mb-5 position-relative">
        <div className="col-1 d-md-none d-inline">
          <div
            className="btn btn-primary d-md-none position-fixed sideBarBtn"
            onClick={(e) => {
              handleCollapse();
              if (isCollapsed) {
                window.scrollTo(0, 0);
              }
            }}
          >
            Show Side Bar
          </div>
        </div>

        <div
          className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? "collapse" : ""
          }`}
        >
          <SideNavComponent />
        </div>

        <div className="col-12 col-md-9 qx-0 px-3">
          <>
            <div className="om-planning-section">
              <h1 id="planningArea">Planning Area</h1>
              <div className="om-planning-intro">
                <p>
                  Users will be able to get the list of the 55 planning areas in
                  Singapore delineated by the Urban Redevelopment Authority
                  (URA). This is helpful for users who want to develop
                  geospatial analytics solutions.
                </p>
              </div>
              <br />
              <h2 id="planningArea">Planning area polygons</h2>
              <div className="om-planning-area">
                <p>
                  This API retrieves all planning area polygons of Singapore in
                  JSON format. Users could enter specified year to get planning
                  area polygons as accordingly. If not specified, api retrieves
                  polygon results for latest master plan year.
                </p>
              </div>
              <h3 className="om-planning-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token in the request header as a
                  bearer token.
                </p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-planning-wrapper">
                <div className="om-planning">
                  <h4 className="om-planning-header">HEADER PARAMETERS</h4>
                </div>
                <div className="om-planning-items">
                  <div className="om-planning-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-planning-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                  {/* <div className='om-reverseGeocode-expand-button'>Expand All</div> */}
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Optional. If not specified, the latest data will be
                        provided. Else, values available are 1998, 2008, 2014,
                        and 2019.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getPlanningareaPoly")} />

              <h2 id="namesofPlanningArea">Names of planning area</h2>
              <div className="om-planning-area">
                <p>
                  This API retrieves the names of all planning areas in
                  Singapore for given year.
                </p>
              </div>
              <h3 className="om-planning-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">400 - Please enter valid year.</p>
                <p className="slate-p">
                  400 - Please send the access token in the request header as a
                  bearer token.
                </p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-planning-wrapper">
                <div className="om-planning">
                  <h4 className="om-planning-header">HEADER PARAMETERS</h4>
                </div>
                <div className="om-planning-items">
                  <div className="om-planning-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-planning-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-theme-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                  {/* <div className='om-reverseGeocode-expand-button'>Expand All</div> */}
                </div>
                <div className="om-theme-items">
                  <div className="om-theme-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Optional. If not specified, the latest data will be
                        provided. Else, values available are 1998, 2008, 2014,
                        and 2019.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getPlanningareaNames")} />

              <h1 id="planningAreaQuery">Planning Area Query</h1>
              <div>
                <p>
                  This API retrieves one planning area polygon based on given
                  latitude and longitude.
                </p>
              </div>
              <h3 className="om-planning-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token in the request header as a
                  bearer token.
                </p>
                <p className="slate-p">400 - Your latitude input is invalid.</p>
                <p className="slate-p">
                  400 - Your longitude input is invalid.
                </p>
                <p className="slate-p">
                  400 - Both your latitude and longitude are missing.
                </p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-planning-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-planning-items">
                  <div className="om-planning-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-planning-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="om-planning-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                  {/* <div className='om-reverseGeocode-expand-button'>Expand All</div> */}
                </div>
                <div className="om-planning-items">
                  <div className="om-planning-item">
                    <div className="label-method">
                      latitude
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>This represents the latitude of the point.</p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      longitude
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>This represents the longitude of the point.</p>
                    </div>
                  </div>
                  <div className="om-planning-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-theme-desc">
                      <p>
                        Optional. If not specified, the latest data will be
                        provided. Else, values available are 1998, 2008, 2014,
                        and 2019.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Endpoint {...endpointreturn("getPlanningarea")} />
            <br />
            <div
              className="d-flex justify-content-between"
              style={{ marginBottom: "20px" }}
            >
              <div className="d-flex justify-content-start">
                <Button
                  onClick={() => {
                    clickButton("6");
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }}
                  style={{
                    backgroundColor: "#FFFFFF",
                    color: "#000000",
                    border: "none",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={arrowleft}
                      alt="arrowleft"
                      style={{ color: "#1978FF", marginRight: "10px" }}
                    />
                    <b>Themes</b>
                  </div>
                </Button>
              </div>
              <div className="d-flex justify-content-end">
                <Button
                  onClick={() => {
                    clickButton("8");
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }}
                  style={{
                    backgroundColor: "#FFFFFF",
                    color: "#000000",
                    border: "none",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <b>Population Query</b>{" "}
                    <img
                      src={arrowright}
                      alt="arrowright"
                      style={{ color: "#1978FF", marginLeft: "10px" }}
                    />
                  </div>
                </Button>
              </div>
            </div>
          </>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};
export default PlanningAreaServices;
